import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Header } from "components/Header";
import theme from "theme";
import { Container } from "@mui/material";
import AlertDialogEmergencyOrder from "components/common/AlertDialogEmergencyOrder";
import AlertDialog from "components/common/AlertDialog";
import AlertDialogManualOrder from "components/common/AlertDialogManualOrder";
import AlertDialogManualPOUpload from "components/common/AlertDialogManualPOUpload";

export const Layout = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <Header></Header>
      <Container maxWidth="false" component="main" sx={{ pt: 3 }} className="commonMainStyling">
        <CssBaseline />
        <AlertDialog />
        <AlertDialogEmergencyOrder />
        <AlertDialogManualOrder />
        <AlertDialogManualPOUpload />
        {props.children}
      </Container>
    </ThemeProvider>
  );
};
